import { getPersonalizer } from '@uniformdev/personalize-react';
import EsiChoose from './components/EsiChoose';
import EsiInclude from './components/EsiInclude';
import EsiOtherwise from './components/EsiOtherwise';
import EsiWhen from './components/EsiWhen';
import EsiForEach from './components/EsiForEach';
import EsiAssign from './components/EsiAssign';
import EsiText from './components/EsiText';
import EsiScript from './components/EsiScript';
import EsiNoOutput from './components/EsiNoOutput';
import EsiNullComponent from './components/EsiNullComponent';
import { EsiContextCsr, EsiContextSsr } from './components/EsiContextDebug';
import getPersonalizedProps from "./getPersonalizedProps";
export var NullComponent = function NullComponent() {
  return null;
};
var esiComponents = new Map();
esiComponents.set('EsiChoose', EsiChoose);
esiComponents.set('EsiInclude', EsiInclude);
esiComponents.set('EsiOtherwise', EsiOtherwise);
esiComponents.set('EsiWhen', EsiWhen);
esiComponents.set('EsiNullComponent', EsiNullComponent);
esiComponents.set('EsiVars', EsiNullComponent);
esiComponents.set('EsiForEach', EsiForEach);
esiComponents.set('EsiAssign', EsiAssign);
esiComponents.set('EsiText', EsiText);
esiComponents.set('EsiScript', EsiScript);
esiComponents.set('EsiNoOutput', EsiNoOutput);
esiComponents.set('EsiContextCsr', EsiContextCsr);
esiComponents.set('EsiContextSsr', EsiContextSsr);
/**
 * Generate a componentFactory function which includes Uniform
 * Personalizer for allowed components
 *
 * @param componentFactory Regular JSS componentFactory function
 * @param include The allowed array is a collection of component names
 *                that support personalization. If the array is empty,
 *                all components are supported. If the array has at
 *                least one item, only the components whose names
 *                match a value in the array are supported.
 * @param exclude The exclude array is a collection of component names
 *                which explicitly do not support personalization.
 */
export function componentFactoryWithUniformPersonalizer(componentFactory, include, exclude) {
  if (include === void 0) {
    include = [];
  }
  if (exclude === void 0) {
    exclude = [];
  }
  var Personalizer = getPersonalizer({
    componentFactory: componentFactory,
    getPersonalizedProps: getPersonalizedProps,
    allowed: include
  });
  return function personalizedComponentFactory(componentName) {
    // Check to see if this is one of the special Esi components
    var esiComponent = esiComponents.get(componentName);
    if (esiComponent) return esiComponent;
    var component = componentFactory(componentName);
    if (!component) {
      return NullComponent;
    }
    if (exclude.includes(componentName)) {
      return component;
    } else if (include.length === 0 || include.includes(componentName)) {
      return Personalizer;
    }
    return component;
  };
}